import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UserManager } from '../../Services/UserManager/user-manager';

@Component({
  selector: 'app-finish-magic-link',
  templateUrl: './finish-magic-link.component.html',
  styleUrls: ['./finish-magic-link.component.css']
})
export class FinishMagicLinkComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private um: UserManager
  ) { }

  ngOnInit(): void {
    let link = window.location.href
    this.um.finishMagicLinkLogin(link)
  }

}
